import { render, staticRenderFns } from "./ProductDetailContentModule.vue?vue&type=template&id=554f7456&scoped=true"
import script from "./ProductDetailContentModule.vue?vue&type=script&lang=js"
export * from "./ProductDetailContentModule.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailContentModule.vue?vue&type=style&index=0&id=554f7456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f7456",
  null
  
)

export default component.exports